import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { GalaxyApi } from "@/api";
import { useFileSourceTemplatesStore } from "@/stores/fileSourceTemplatesStore";
import { errorMessageAsString } from "@/utils/simple-error";
import { useInstanceRouting } from "./routing";
import CreateForm from "@/components/FileSources/Instances/CreateForm.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateInstance',
    props: {
        templateId: null,
        uuid: null
    },
    setup(__props) {
        const props = __props;
        const OAUTH2_TYPES = ["dropbox", "googledrive"];
        const fileSourceTemplatesStore = useFileSourceTemplatesStore();
        fileSourceTemplatesStore.fetchTemplates();
        const { goToIndex } = useInstanceRouting();
        const loading = ref(false);
        const errorMessage = ref("");
        const template = computed(() => fileSourceTemplatesStore.getLatestTemplate(props.templateId));
        const redirectMessage = computed(() => `You will redirected to ${template.value?.name} to authorize Galaxy to access this resource remotely. Please wait`);
        const requiresOAuth2AuthorizeRedirect = computed(() => {
            const templateValue = template.value;
            return props.uuid == undefined && templateValue && OAUTH2_TYPES.indexOf(templateValue.type) >= 0;
        });
        function onCreated(objectStore) {
            const message = `Created file source ${objectStore.name}`;
            goToIndex({ message });
        }
        watch(requiresOAuth2AuthorizeRedirect, async (requiresAuth) => {
            const templateValue = template.value;
            if (templateValue && requiresAuth) {
                loading.value = true;
                const { data, error: testRequestError } = await GalaxyApi().GET("/api/file_source_templates/{template_id}/{template_version}/oauth2", {
                    params: {
                        path: {
                            template_id: templateValue.id,
                            template_version: templateValue.version || 0,
                        },
                    },
                });
                if (testRequestError) {
                    errorMessage.value = errorMessageAsString(testRequestError, "Error getting OAuth2 URL");
                    loading.value = false;
                }
                else {
                    window.location.href = data.authorize_url;
                }
            }
        }, { immediate: true });
        return { __sfc: true, OAUTH2_TYPES, fileSourceTemplatesStore, goToIndex, props, loading, errorMessage, template, redirectMessage, requiresOAuth2AuthorizeRedirect, onCreated, BAlert, CreateForm, LoadingSpan };
    }
});
